// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data_wrap[data-v-b0c4d214]{display:flex;flex-direction:column;height:100%}.handle-input[data-v-b0c4d214]{width:200px;display:inline-block}.searchBtn[data-v-b0c4d214]{height:30px;background:#3b7bcf}.verticalCol[data-v-b0c4d214]{display:flex;flex-direction:column}.myDrawer[data-v-b0c4d214]{width:60%}.dialog_header[data-v-b0c4d214]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex:1;color:#fff}", ""]);
// Exports
module.exports = exports;
